import { OBJECT } from '@/plugins/sdk/fields'
import isEqual from 'lodash/isEqual'
import isPlainObject from 'lodash/isPlainObject'

export default class extends OBJECT {
  constructor (resource) {
    super(null)

    Object.defineProperties(this, {
      _resource: {
        configurable: false,
        enumerable: false,
        value: resource,
        writable: false
      }
    })
  }

  static name = 'item'

  /** @inheritdoc */
  get modified () {
    let modified = !isEqual(JSON.stringify(this._default), JSON.stringify(this._current))

    if (!modified) {
      const resource = this.current

      if (resource instanceof this._resource) {
        modified = !!resource.modified
      }
    }

    return modified
  }

  /** @inheritdoc */
  mutator (value) {
    let resource = value

    if (value instanceof this._resource) {
      resource = value.clone()
    } else if (typeof value !== 'undefined' && value !== null) {
      resource = new this._resource()

      if (isPlainObject(value)) {
        resource.fill(value, true)
      }
    }

    return resource
  }

  /** @inheritdoc */
  reset () {
    let resource = this.default

    if (resource instanceof this._resource) {
      resource = resource.clone()
    }

    this._current = resource
  }

  /** @inheritdoc */
  copy () {
    let copy
    const resource = this.current

    if (resource instanceof this._resource) {
      copy = resource.replicate()
    }

    return copy
  }
}
